import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { AppLayout } from 'containers';
import { ClientDetail } from 'containers/Admin';

var OrgClientDetail = /*#__PURE__*/function (_Component) {
  _inherits(OrgClientDetail, _Component);

  var _super = _createSuper(OrgClientDetail);

  function OrgClientDetail() {
    _classCallCheck(this, OrgClientDetail);

    return _super.apply(this, arguments);
  }

  _createClass(OrgClientDetail, [{
    key: "render",
    value: function render() {
      var appLayoutInnerStyle = {
        display: 'flex',
        flex: '1 1 auto',
        padding: 0,
        overflow: 'auto',
        height: '100%'
      };
      return /*#__PURE__*/React.createElement(AppLayout, {
        appLayoutInnerStyle: appLayoutInnerStyle,
        params: _objectSpread({}, this.props.params)
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Client Detail"
      }), /*#__PURE__*/React.createElement(ClientDetail, {
        isOrgClientDetailView: true,
        clientId: this.props.params.organizationId
      }));
    }
  }]);

  return OrgClientDetail;
}(Component);

export default OrgClientDetail;